/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('accessWebClient')
    .controller('NodeLinksModalController', [
        '$scope', '$modalInstance', '$q', 'element', 'template', 'NodeShareLink', 'DateTools',
        function ($scope, $modalInstance, $q, element, template, NodeShareLink, DateTools) {
            var
                links = [];

            $scope.modal = $modalInstance.options;
            $scope.modal.footerTemplate = template('links/_modal_footer');
            $scope.element = element;

            $scope.showTableCaptions = $scope.modal.action === 'fileAndEsignatureLinksList';
            $scope.showEsignatureColumns = $scope.modal.action === 'fileAndEsignatureLinksList';

            $scope.reload = function () {
                links = NodeShareLink.query({
                    node_uuid: element.uuid,
                    esignature_id: element.esignatureID
                });

                links.$promise.then(function () {
                    $scope.originalLinks = links.filter(function (link) {
                        return link.esignature === null;
                    });
                    $scope.esignatureLinks = links.filter(function (link) {
                        return link.esignature;
                    });
                })
            };

            $scope.reload()

            $scope.done = function () {
                var
                    requests = [];

                angular.forEach(links, function (link) {
                    if (link.changed && !link.deleted_at) {
                        requests.push(NodeShareLink.update({
                            node_uuid: element.uuid,
                            id: link.id,
                            ttl: (parseInt(link.days_until_expiration) + DateTools.daysSince(link.created_at)),
                            single_use: link.single_use,
                            access_restriction: link.access_restriction
                        }).$promise);
                    }
                });

                $q.all(requests).then(function () {
                    $modalInstance.close('reload_nodes');
                });
            };

            $scope.cancel = $scope.close = function () {
                $modalInstance.dismiss('cancel');
            };
        }]);
